<template>
  <v-card color="grey lighten-4" flat tile>
    <v-toolbar elevation="1">
      <v-toolbar-title>Products</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        color="cleed_blue"
        :dark="shopify.accessInfos.access_token ? true : false"
        @click="download"
        :disabled="!shopify.accessInfos.access_token"
      >
        <b>export</b>
        <v-icon class="ma-2">mdi-tray-arrow-down</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pt-1 pb-0 px-0">
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1 px-0 mx-0"
      >
        <template v-slot:item="{ item }">
          <tr :data-id="item.id">
            <td>
              <span class="caption my-0 py-0">
                {{ item.id }}
              </span>
            </td>
            <td>
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <v-card>
                    <v-img
                      height="70"
                      width="120"
                      :src="item.image"
                      lazy-src="https://picsum.photos/id/11/10/6"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </td>
            <td>
              <h5>
                {{ item.title }}
              </h5>
            </td>
            <td>
              {{ item.tags }}
            </td>
            <td>
              {{ item.product_type }}
            </td>
            <td>
              {{ item.vendor }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "shopify_Products",
  data: () => ({
    headers: [
      {
        text: "Product id",
        align: "start",
        value: "id",
      },
      {
        text: "Product image",
        align: "center",
        value: "image.src",
        sortable: false,
      },
      { text: "Product Title", value: "title" },
      { text: "Product Tags", value: "tags", sortable: false },
      { text: "Product Type", value: "type", sortable: false },
      { text: "Product Vendor", value: "vendor", sortable: false },
    ],
    desserts: undefined,
  }),
  computed: {
    shopify() {
      const data = this.$store.state.shopify.credentials;
      return data;
    },
  },
  created() {
    if (this.shopify.accessInfos.access_token) {
      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Scraping products",
      });
      this.$store
        .dispatch("SHOPIFY_GET_PRODUCTS", {
          shop: this.shopify.accessInfos.shop,
          accessToken: this.shopify.accessInfos.access_token,
        })
        .then((res) => {
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.desserts = res;
          console.log(res);
        })
        .catch((err) => {
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          console.log(err.response.data || err.response);
        });
    }
  },
  methods: {
    download() {
      this.saveJSON(this.desserts, `${this.shopify.accessInfos.shop}.json`);
    },
    saveJSON(data, filename) {
      if (!data) {
        console.error("No data");
        return;
      }

      if (!filename) filename = "products.json";

      if (typeof data === "object") {
        data = JSON.stringify(data, undefined, 4);
      }

      var blob = new Blob([data], { type: "text/json" }),
        e = document.createEvent("MouseEvents"),
        a = document.createElement("a");

      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
  },
};
</script>
